<div class="warpper-form-question">
    <div class="contain">
        <!-- *ngIf="(listForm.controls.answerOptionItem.value?.length??0)<6; else noUserList" -->
        <que-generic-form-array #generic [formControl]="listForm.controls.answerOptionItem"
            [itemTemplate]="itemTemplate" [addDefaultItem]="newItem()" [addBtnTemplate]="addBtnTemplate"
            class="component">
            <ng-template #itemTemplate let-item="control" let-i="index">
                <que-answer-option-item-input [formControl]="item" [typeId]="question?.type?.id"
                    [questionId]="question?.id" [isSmartQuestion]="question?.collectionQuestionId!=null"
                    [isPublic]="listForm.controls.isPublic.value" (deleteEvent)="generic.remove(i)" [isInFollowQuestion]="question?.followAnswerOptionItemGuid!=null">
                </que-answer-option-item-input>
            </ng-template>
            <ng-template #addBtnTemplate let-item="control" let-i="index">
                <!-- *ngIf="(listForm.controls.answerOptionItem.value?.length??0)<10" -->
                <div *ngIf="!listForm.controls.isPublic.value && !question?.collectionQuestionId"
                    class="pointer addOp right" translate>
                    <img src="/assets/images/options/add-option.svg">
                    questionBoard.edit.add-option
                </div>
            </ng-template>
        </que-generic-form-array>
    </div>
    <div class="selected" #trigger (click)="question?.collectionQuestionId?null:isSelectOpen=true">
        <p translate *ngIf="!selectedTypeName">questionBoard.edit.lists-placeholder</p>
        <p *ngIf="selectedTypeName">{{selectedTypeName}}</p>
        <img *ngIf="!question?.collectionQuestionId" src="/assets/images/arrow-down.svg" />
    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
        (backdropClick)="isSelectOpen=false" [cdkConnectedOverlayOpen]="isSelectOpen"
        [cdkConnectedOverlayPositions]="positonArea">
        <div class="menuSteps">
            <div translate *ngIf="(allOptionLists$()?.length??0)==0">no-result.no-result</div>
            <div class="op" *ngIf="(allOptionLists$()?.length??0)!=0">
                <p translate (click)="selectWithout()">
                    Custom List
                </p>
            </div>
            <div *ngFor="let op of allOptionLists$() " class="op">
                <p translate (click)="updateSelection(op)">
                    {{op.name}}
                </p>
            </div>
        </div>
    </ng-template>
</div>
<!-- <ng-template #noUserList>
    <div class="op-input noUserList">
        <img class="img-o" src="/assets/images/collection.svg" />
        <p>{{listForm.controls.name.value}}</p>
    </div>
</ng-template> -->